import React from 'react'
import AcademicForm from '../../features/AcademicMemberTaskList/AcademicForm'

const AcademicMember = () => {
    return (
        <AcademicForm />
    )
}

export default AcademicMember